module.exports = __webpack_public_path__ + "img/successTip.0b604a17.png";